import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";
import { useState } from "react";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useAssetDetails = (projectId: string | undefined) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);

    const changePage = (newPage: number) => {
        setPage(newPage);
    };

    const changeRowsPerPage = (newLimit: number) => {
        setPage(1);
        setLimit(newLimit);
    };

    const { data, isFetching, isPending, isError, isRefetching, refetch } = useQuery({
        queryKey: ["project-asset", projectId, page, limit],
        queryFn: () => projectDetailsApi.fetchProjectAssets(projectId, page, limit),
    });

    return {
        assetData: data?.data?.rows,
        assetDataPagination: data?.data?.pagination,
        isPending, isFetching, isError,
        changePage, changeRowsPerPage,
        isRefetching, refetch,
        removeCache: () => { queryClient.removeQueries({ queryKey: ["project-asset", projectId] }); }
    };

}